var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEditMode)?_c('V2RequestCreate',_vm._b({attrs:{"id":_vm.requestId,"resource":"request"}},'V2RequestCreate',_vm.$attrs,false)):_c('V2Layout',[_c('div',{staticClass:"v2-page-wrap"},[_c('V2Review',{key:_vm.$route.fullPath,attrs:{"id":_vm.requestId,"resource":_vm.$attrs.resource || 'request'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }